// src/utils/auth.js
// Utility functions สำหรับ authentication

/**
 * สร้าง Authorization header สำหรับ API requests
 * @returns {Object} Headers object พร้อม Authorization header
 */
export const authHeader = () => {
  const token = sessionStorage.getItem("access_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * ดึง access token จาก sessionStorage
 * @returns {string|null} Access token หรือ null ถ้าไม่มี
 */
export const getAccessToken = () => {
  return sessionStorage.getItem("access_token");
};

/**
 * ตรวจสอบว่า user login อยู่หรือไม่
 * @returns {boolean} true ถ้า login อยู่, false ถ้าไม่
 */
export const isLoggedIn = () => {
  return (
    typeof window !== "undefined" &&
    sessionStorage.getItem("isLoggedIn") === "true" &&
    sessionStorage.getItem("access_token") !== null
  );
};

/**
 * Logout user และลบข้อมูล authentication ทั้งหมด
 * @param {Function} navigate - React Router navigate function
 * @param {Function} [onClose] - Optional callback function (เช่น setAccountOpen, setMobileOpen)
 */
export const handleLogout = (navigate, onClose) => {
  // ลบข้อมูล authentication ทั้งหมดจาก sessionStorage เพื่อความปลอดภัย
  sessionStorage.removeItem("isLoggedIn");
  sessionStorage.removeItem("access_token");
  sessionStorage.removeItem("token_type");
  
  // ลบข้อมูล sessionStorage ที่เกี่ยวข้อง
  sessionStorage.removeItem("postLoginRedirect");
  sessionStorage.removeItem("selectedLicenseKey");
  sessionStorage.removeItem("pendingLicenseQuery");
  
  // ลบข้อมูล localStorage ที่อาจเหลืออยู่ (backward compatibility)
  localStorage.removeItem("isLoggedIn");
  localStorage.removeItem("access_token");
  localStorage.removeItem("token_type");
  
  // Call optional callback (เช่น ปิด menu)
  if (onClose) {
    onClose();
  }
  
  // ใช้ window.location.href เพื่อ force reload และให้แน่ใจว่า state ถูก reset
  // วิธีนี้จะทำให้ component ทั้งหมด re-render และตรวจสอบ isLoggedIn state ใหม่
  window.location.href = "/login";
};

/**
 * ตรวจสอบและจัดการ 401 error (Unauthorized)
 * @param {Response} response - Fetch response object
 * @param {Function} navigate - React Router navigate function
 * @returns {boolean} true ถ้าเป็น 401 และได้จัดการแล้ว, false ถ้าไม่ใช่ 401
 */
export const handle401Error = (response, navigate) => {
  if (response.status === 401) {
    // ลบข้อมูลจาก sessionStorage
    sessionStorage.removeItem("isLoggedIn");
    sessionStorage.removeItem("access_token");
    sessionStorage.removeItem("token_type");
    
    // ลบข้อมูล localStorage ที่อาจเหลืออยู่ (backward compatibility)
    localStorage.removeItem("isLoggedIn");
    localStorage.removeItem("access_token");
    localStorage.removeItem("token_type");
    
    if (navigate) {
      navigate("/login");
    }
    return true;
  }
  return false;
};
